import { getApp, getApps, initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getToken, isSupported, onMessage } from "firebase/messaging";
import { getMessaging } from "firebase/messaging/sw";
import { getStorage } from "firebase/storage";
import { toast } from "react-toastify";

import { isItDev } from "../helper/isItDev";
import { createUserLog } from "./logs";
import { saveFCMToken } from "./notification";

const firebaseConfig = {
  apiKey: process.env.NEXT_PUBLIC_API_KEY,
  authDomain: process.env.NEXT_PUBLIC_AUTH_DOMAIN,
  projectId: process.env.NEXT_PUBLIC_PROJECT_ID,
  storageBucket: process.env.NEXT_PUBLIC_STORAGE_BUCKET,
  messagingSenderId: process.env.NEXT_PUBLIC_MESSAGING_SENDER_ID,
  appId: process.env.NEXT_PUBLIC_APP_ID,
  measurementId: process.env.NEXT_PUBLIC_MEASUREMENT_ID,
};

// const app = initializeApp(firebaseConfig);
const app = !getApps().length ? initializeApp(firebaseConfig) : getApp();
const db = getFirestore(app);
const auth = getAuth(app);
const storage = getStorage(app);
auth.useDeviceLanguage();

const firebaseCloudMessaging = {
  tokenInLocalStorage: async () => {
    const token = localStorage.getItem("fcm_token");
    return token;
  },
  onMessage: async () => {
    const messaging = getMessaging(app);
    onMessage(messaging, (payload) => {});
  },
  init: async function () {
    try {
      const permitted = await requestForToken();
      if (!permitted) {
        return false;
      }
      if ((await this.tokenInLocalStorage()) !== null) {
        return false;
      }

      const messaging = getMessaging(app);
      const currentToken = await getToken(messaging, {
        vapidKey: process.env.NEXT_FCM_WEB_KEY_PAIR,
      });
      if (currentToken) {
        if (auth.currentUser?.uid) {
          localStorage.setItem("fcm_token", currentToken);
          await saveFCMToken(auth.currentUser?.uid, currentToken);
        }
      } else {
        // Show permission request UI
        await requestForToken();
      }
    } catch (error) {
      isItDev() && toast.error("Something went Wrong");
      console.error("ERROR CODE: 89767. Brave Browser Issue");
      console.log(error);
    }
  },
};

export const requestForToken = async () => {
  if (!isSupported) {
    return;
  }
  try {
    const permission = await Notification.requestPermission();
    if (permission === "granted") {
      return true;
    } else if (permission === "denied") {
      return false;
    }
  } catch (error) {}
};

export { app, auth, db, firebaseCloudMessaging, storage };
